<template>
  <div class="custom-select-component">
    <button
      @click="show = !show"
      class="btn btn-custom-select d-flex align-items-center"
    >
      <span class="mr-4">{{ textSelected() }}</span>
      <i class="icon-arrow_drop_down"></i>
    </button>

    <div v-if="show" class="d-flex flex-column position-absolute op">
      <button
        @click="changeSelected(option)"
        class="btn options"
        v-for="option in options"
        :key="option.value"
      >
        {{ option.text }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: {},
      show: false
    };
  },
  methods: {
    changeSelected(option) {
      this.selected = option;
      this.$emit("filter", this.selected);
      this.show = false;
    },
    textSelected() {
      if (this.selected && this.selected.text) {
        return this.selected.text;
      } else {
        return this.options[0].text;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-select-component {
  position: relative;

  .btn-custom-select {
    border: 1px solid #2c2c2c;
    border-radius: 6px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    color: #f2f2f2;
    min-width: 150px;

    i {
      font-size: 12px;
      color: #ffffff;
    }

    @media screen and (max-width: 991px) {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;

      i {
        font-size: 8px;
      }
    }
  }

  .op {
    z-index: 9999;
    background: #111112;
    border-radius: 8px;
    padding: 8px;

    .options {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 130%;
      color: #ffffff;
      text-align: left !important;
      border-bottom: 2px solid #2c2c2c;
      border-radius: 0;

      &:hover {
        filter: brightness(80%);
      }
    }
    @media screen and (max-width: 991px) {
      .options {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
      }
    }
  }
}
</style>
